/*
 * Copyright (c) 2025 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { CurrencyValueModel } from '@well/domain';
import { TaskListWithRouteDTO } from './task-list-with-route-dto.model';

export class TaskListWithCostDtoModel extends TaskListWithRouteDTO {
  cost: CurrencyValueModel | null = null;
  routedOrderTemplateDraftUuids: string[] | undefined = undefined;
}
